export default __webpack_public_path__ + "static/media/ic-edit.380f143b.svg";